// Dashboard Users registration quality page translations (pt-BR), loaded into dashboard.users.registration by ../pt-BR.users.js
module.exports = {
  menu: "Qualidade do Cadastro",
  title: "Qualidade do Cadastro",
  description: "Qualidade do perfil e origem do cadastro.",
  fields: {
    complete: "Perfil completo",
    avatar: "Foto de avatar",
    cover: "Foto de capa",
    bio: "Biografia",
    birthDate: "Data de nascimento",
    gender: "Género informado",
  },
  filledSub: "{filled} · {empty} sem",
  emptySub: "{empty} vazios · {filled} preenchidos",
  origins: {
    google: "Google",
    apple: "Apple",
    email: "Email",
  },
  donut: {
    complete: "Completos",
    incomplete: "Incompletos",
    completeSub: "completos",
    originSub: "cadastros",
  },
  panels: {
    filled: "Campos preenchidos",
    filledNote: "Situação da base a {date}.",
    empty: "Campos menos preenchidos",
    emptyNote: "Percentagem de perfis com o campo vazio — mostra onde melhorar o onboarding.",
    complete: "Perfis completos",
    origin: "Origem do cadastro — novos no período",
    originNote: "Quantidade absoluta e percentual por método de login.",
  },
  panelInfo: {
    filled: "Perfis ativos com cada campo preenchido no fim do período.\nFonte: Firebase (índice de perfis).",
    empty: "Perfis ativos com cada campo vazio no fim do período.\nFonte: Firebase (índice de perfis).",
    complete: "Perfis ativos completos e incompletos no fim do período.\nFonte: Firebase (índice de perfis).",
    origin: "Contas criadas no período por método de login (Google, Apple ou e-mail).\nFonte: Firebase (Authentication, guardado no índice de perfis).",
  },
};
